import { LocalComponent } from "~/ecs/base"

export class BoneAttachError extends LocalComponent {}
